module.exports = __webpack_public_path__ + "static/007218-5f5a63dd7d30392d576859345a0d27d4.jpg";